"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _coreSc = require("@smooth-ui/core-sc");

var Wrapper = (0, _coreSc.styled)(_coreSc.Box).withConfig({
  displayName: "Wrapper",
  componentId: "h9worm-0"
})(["margin:0 auto;padding:0 24px;width:100%;max-width:1180px;"]);
var _default = Wrapper;
exports["default"] = _default;